import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) => ({
  Wrapper: {
    height: 'auto',
    width: '100%',
    position: 'relative',
    '& .MuiTypography-h6': {
      fontSize: '17px',
    },
  },
  Header: {
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    height: '70px',
    gap: '20px',
    '& p': { fontSize: 'larger' },
    '& span': { color: 'orange', fontSize: '20px' },
  },
  ToMain: {
    fontSize: '20px',
    cursor: 'pointer',
  },
  FilterRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '16px',
    flexWrap: 'wrap',
    padding: '0 10px',
  },
  SummarySection: {
    margin: '0 10px 16px',
    padding: '16px',
    border: '1px solid #fc7f03',
    borderRadius: '8px',
  },
  SummaryStats: {
    display: 'flex',
    gap: '24px',
    flexWrap: 'wrap',
    marginTop: '12px',
  },
  StatCard: {
    padding: '12px 20px',
    borderRadius: '8px',
    backgroundColor: '#ede9e4',
    textAlign: 'center' as const,
  },
}));
